module.exports = __webpack_public_path__ + "static/img/5.c48e585.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/5.jpg
// module id = yunN
// module chunks = 1